import { forwardRef } from "react";

import { Button, type ButtonProps } from "./button";

export const TertiaryButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, children, onClick, isDisabled, size, ...restProps }, ref) => {
    return (
      <Button
        className={className}
        variant="tertiary"
        isDisabled={isDisabled}
        onClick={onClick}
        size={size}
        ref={ref}
        {...restProps}
      >
        {children}
      </Button>
    );
  },
);
